import { CourseStatus } from './course-satellite';
import { DomainError } from '../errors/domain-error';

export function canAdminTakedownCourse(status: string): boolean {
  return status !== CourseStatus.ARCHIVED;
}

export function assertAdminCourseTakedown(status: string): void {
  if (!canAdminTakedownCourse(status)) {
    throw new DomainError('Course is already taken down');
  }
}

export function canBanCourseStudent(params: {
  actorUserId: string;
  learnerUserId: string;
}): { allowed: boolean; reason?: string } {
  if (params.actorUserId === params.learnerUserId) {
    return { allowed: false, reason: 'You cannot ban yourself from your course' };
  }
  return { allowed: true };
}

export function buildCourseReportHref(slug: string | null): string | null {
  return slug ? `/courses/${slug}` : null;
}

export function buildCourseLessonReportHref(
  slug: string | null,
  lessonId: string,
): string | null {
  return slug ? `/courses/${slug}/learn?lesson=${lessonId}` : null;
}
